import { ExtendedModelBase } from '../../Models/extendedModelBase';

export class ExtendedContactModel extends ExtendedModelBase<Core.ContactModel> {
    constructor(model: Core.ContactModel) {
        super(model);
        this.displayName = `${this.model.firstName} ${this.model.lastName}`;
    }

    displayName: string;
}

export class ExtendedContactShortModel extends ExtendedModelBase<Core.ContactShortModel> {
    constructor(model: Core.ContactShortModel) {
        super(model);
        this.displayName = `${this.model.firstName} ${this.model.lastName}`;
    }

    displayName: string;
}

export class ExtendedUserTeamModel extends ExtendedModelBase<Core.UserTeamModel> {
    constructor(model: Core.UserTeamModel) {
        super(model);
        this.displayName = `${this.model.firstName} ${this.model.lastName} ${this.model.teamName ? ` (${this.model.teamName})` : ''}`;
    }

    displayName: string;
}
